export const ACCESS_TOKEN_KEY = 'accessToken';
export const REFRESH_TOKEN_KEY = 'refreshToken';
export const TOKEN_EXPIRY_KEY = 'accessTokenExp';
export const CLIENT_AUTHORIZATION = 'Basic cm1zLWZyb250ZW5kOm5vb25ld2lsbGV2ZXJndWVzcw==';
